/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */


export const Constants = {
    PREFIX_GROUPS: "groups",
    PREFIX_NODES: "nodes",
    PREFIX_USERS: "users",
    PREFIX_ROLES: "roles",
    PREFIX_ALLROLES: "all-roles",
    PREFIX_LOG_CONFIGS: "log-configs",
    PREFIX_LOGS: "logs",
    PREFIX_RESOURCE_TYPE: "resource-type",
    PREFIX_USER_PASSWORD: "user/password"
};
